// extracted by mini-css-extract-plugin
module.exports = {"full-width-text":"styles_full-width-text__2S9zS","container":"styles_container__q6jnE"};